import { explorerAddress } from '../ton/config';
import { shortenAddress } from '../lib/format';

interface ExplorerLinkProps {
  address: string | null;
  /** Render the full address instead of a shortened form. */
  full?: boolean;
  label?: string;
  /**
   * Override the link target (e.g. a transaction) while still displaying the
   * address as the visible text. Falls back to the address page when omitted.
   */
  href?: string;
}

/** A shortened, copyable, click-through link to an address on the explorer. */
export function ExplorerLink({ address, full, label, href }: ExplorerLinkProps) {
  if (!address) return <span className="detail-value">—</span>;
  return (
    <a
      className="explorer-link"
      href={href ?? explorerAddress(address)}
      target="_blank"
      rel="noopener noreferrer"
      title={address}
    >
      {label ?? (full ? address : shortenAddress(address, 6, 6))}
      <span className="explorer-link__icon" aria-hidden>↗</span>
    </a>
  );
}
